import { ConsumerSkuType } from '@office-start/officehome-types';
/**
 * Get whether or not the current sku is considered 'subscribed'
 * @param skuType consumer sku type
 * @returns true if user does not contain free SKU types, false otherwise.
 */
export var getIsSubscribedFromSkuType = function (skuType) {
    // Not subscribed / Free
    if (skuType === ConsumerSkuType.NotSubscribed ||
        skuType === ConsumerSkuType.NotDetected ||
        skuType === ConsumerSkuType.NonActive ||
        skuType === ConsumerSkuType.Perpetual ||
        skuType === ConsumerSkuType.Perpetual2019) {
        return false;
    }
    // Subscribed
    return true;
};
//# sourceMappingURL=getIsSubscribedFromSkuType.js.map